/**
 * Official UTMify UTM tracking script loader.
 * Injects https://cdn.utmify.com.br/scripts/utms/latest.js once per page load.
 * This is independent from the Meta Pixel setup in lib/pixel.ts.
 */

const UTMIFY_SCRIPT_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'
const UTMIFY_SCRIPT_ID = 'utmify-utms-script'

export function loadUtmify(): void {
  if (typeof document === 'undefined') return
  if (document.getElementById(UTMIFY_SCRIPT_ID)) return

  const script = document.createElement('script')
  script.id = UTMIFY_SCRIPT_ID
  script.src = UTMIFY_SCRIPT_SRC
  script.async = true
  script.defer = true
  script.setAttribute('data-utmify-prevent-xcod-sck', '')
  script.setAttribute('data-utmify-prevent-subid', '')
  document.head.appendChild(script)
}
